module.exports = __webpack_public_path__ + "static/media/deep-fry.490826d4.png";